/*
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './contexts/appContext';
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from './pages/Error/Fallback_Error_Boundary/ErrorFallback';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => (
          <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
        )}
      >
      
        <AppProvider>
          <App />
        </AppProvider>
      </ErrorBoundary>
    
  </React.StrictMode>
);

reportWebVitals();
*/



import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './contexts/appContext';
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from './pages/Error/Fallback_Error_Boundary/ErrorFallback';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary
          fallbackRender={({ error, resetErrorBoundary }) => (
            <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
          )}
        >
      
          <AppProvider>
            <App />
          </AppProvider>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
